import { Number } from "core-js";

const state = function() {
  return {
    isResponse: Number,
    isMsg: String
  };
};

export default state;
